import GlobalStyle from './GlobalStyle';
import styled, { createGlobalStyle, css, keyframes, ThemeProvider, withTheme } from 'styled-components';
import theme from './theme';

export { css, createGlobalStyle, keyframes, ThemeProvider, withTheme, theme, GlobalStyle };
export default styled;
